import React from "react";
import YouTubePlayer from "../YouTubePlayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import PageHeading from "../PageHeading";

const About = () => {
  return (
    <div className="flex flex-col justify-center items-center bg-gradient-to-r from-[#1E464B] to-[#2A6268] text-white py-8 px-4">
      <PageHeading 
        heading="About Fotosoc" 
        subheading="Watch this video to learn all about DCU's Photography Society"
      />
      <div className="video-container rounded-xl overflow-hidden shadow-2xl mb-8">
        <YouTubePlayer />
      </div>
     <div className="bg-white rounded-lg shadow-xl p-6 mt-10 w-full max-w-sm sm:max-w-md md:max-w-lg">
  <h3 className="text-xl font-bold mb-4 text-black text-center pb-4">
    Check Out Our Socials!
  </h3>
  <ul className="flex flex-wrap justify-center gap-6 items-center">
  <li className="p-2">
    <a
      href="https://www.tiktok.com/@dcufotosoc"
      aria-label="DCU Fotosoc TikTok"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faTiktok} className="text-gray-800 hover:text-gray-600 text-5xl hvr-bob" />
    </a>
  </li>
  <li className="p-2">
    <a
      href="https://instagram.com/dcufotosoc"
      aria-label="DCU Fotosoc Instagram"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faInstagram} className="text-gray-800 hover:text-gray-600 text-5xl hvr-bob" />
    </a>
  </li>
  <li className="p-2">
    <a
      href="mailto:committee@dcufotosoc.ie"
      aria-label="DCU Fotosoc Email"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faEnvelope} className="text-gray-800 hover:text-gray-600 text-5xl hvr-bob" />
    </a>
  </li>
  <li className="p-2">
    <a
      href="https://www.youtube.com/@dcufotosoc3388"
      aria-label="DCU Fotosoc YouTube"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faYoutube} className="text-gray-800 hover:text-gray-600 text-5xl hvr-bob" />
    </a>
  </li>
  {/*<li className="p-2">
    <a
      href="https://facebook.com/DCUPhotographySociety"
      aria-label="DCU Fotosoc Facebook"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faFacebook} className="text-gray-800 hover:text-gray-600 text-5xl hvr-bob" />
    </a>
  </li>

  <li className="p-2">
    <a
      href="https://www.linkedin.com/company/dcufotosoc"
      aria-label="DCU Fotosoc LinkedIn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faLinkedin} className="text-gray-800 hover:text-gray-600 text-5xl hvr-bob" />
    </a>
  </li>*/}
</ul>

</div>

    </div>
  );
};

export default About;
